export default {
    headline: {
        "font-weight": "800",
        "text-anchor": "end",
       // "font-family": "TheMix",
        "font-size": "24px",
        "fill": "#00183a"
    },
    bottomLogo: {

    },
    labels: {
        "text-anchor": "middle",
        "font-weight": "500",
        //"font-family": "TheMix",
        "font-size": "22px",
        "fill": "rgb(68, 68, 68)"
    },
    party: {
        "text-anchor": "middle",
        "font-weight": "500",
        //"font-family": "TheMix",
        "font-size": "22px",
        "fill": "#ffffff"
    }
}
